import type { IconName } from '../../lib/navigation'

interface NavIconProps {
  name: IconName
  size?: number
}

export function NavIcon({ name, size = 14 }: NavIconProps) {
  const s = {
    width: size,
    height: size,
    viewBox: '0 0 16 16' as const,
    fill: 'none' as const,
    stroke: 'currentColor' as const,
    strokeWidth: 1.5,
    className: 'shrink-0',
  }

  switch (name) {
    case 'grid':
      return (
        <svg {...s}>
          <rect x="1" y="1" width="6.5" height="6.5" rx="1"/>
          <rect x="8.5" y="1" width="6.5" height="6.5" rx="1"/>
          <rect x="1" y="8.5" width="6.5" height="6.5" rx="1"/>
          <rect x="8.5" y="8.5" width="6.5" height="6.5" rx="1"/>
        </svg>
      )
    case 'bars':
      return (
        <svg {...s}>
          <rect x="1" y="9" width="3" height="6" rx=".5"/>
          <rect x="6.5" y="5.5" width="3" height="9.5" rx=".5"/>
          <rect x="12" y="2" width="3" height="13" rx=".5"/>
        </svg>
      )
    case 'users':
      return (
        <svg {...s}>
          <circle cx="6" cy="5" r="3"/>
          <path d="M1 14c0-2.8 2.2-4.5 5-4.5s5 1.7 5 4.5"/>
          <circle cx="12" cy="4.5" r="2.5"/>
          <path d="M11 10.5c1.2-.5 3.2.3 3.7 2"/>
        </svg>
      )
    case 'bell':
      return (
        <svg {...s}>
          <path d="M8 1.5A4.5 4.5 0 003.5 6v3.5L2 11.5h12l-1.5-2V6A4.5 4.5 0 008 1.5z"/>
          <path d="M6.5 11.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5"/>
        </svg>
      )
    case 'briefcase':
      return (
        <svg {...s}>
          <rect x="1" y="4" width="14" height="10" rx="1"/>
          <path d="M4 4V2.5a.5.5 0 01.5-.5h7a.5.5 0 01.5.5V4"/>
          <path d="M1 8h14"/>
        </svg>
      )
    case 'shield':
      return (
        <svg {...s}>
          <path d="M8 1L2 4.2v3.5c0 3.5 2.6 6.8 6 7.8 3.4-1 6-4.3 6-7.8V4.2L8 1z"/>
        </svg>
      )
    case 'gear':
      return (
        <svg {...s}>
          <circle cx="8" cy="8" r="2.5"/>
          <path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.4 3.4l1.4 1.4M11.2 11.2l1.4 1.4M3.4 12.6l1.4-1.4M11.2 4.8l1.4-1.4"/>
        </svg>
      )
    case 'calendar':
      return (
        <svg {...s}>
          <rect x="1" y="2" width="14" height="13" rx="1"/>
          <path d="M1 6h14M5 1v3M11 1v3"/>
        </svg>
      )
    case 'chart-line':
      return (
        <svg {...s}>
          <path d="M1 11l3-5 3.5 3.5 3-5.5 3.5 4"/>
          <circle cx="4" cy="6" r=".8" fill="currentColor" stroke="none"/>
          <circle cx="7.5" cy="9.5" r=".8" fill="currentColor" stroke="none"/>
          <circle cx="10.5" cy="4" r=".8" fill="currentColor" stroke="none"/>
        </svg>
      )
    // Spec 161 — une icône distincte par entrée du menu par tâches (menu en icônes sous 1 280 px).
    case 'help':
      return (
        <svg {...s}>
          <circle cx="8" cy="8" r="6.5"/>
          <path d="M6.2 6.2a1.9 1.9 0 013.6.8c0 1.3-1.8 1.6-1.8 2.8"/>
          <circle cx="8" cy="11.6" r=".7" fill="currentColor" stroke="none"/>
        </svg>
      )
    case 'sliders':
      return (
        <svg {...s}>
          <path d="M2 4h12M2 8h12M2 12h12"/>
          <circle cx="5.5" cy="4" r="1.5" fill="currentColor" stroke="none"/>
          <circle cx="10.5" cy="8" r="1.5" fill="currentColor" stroke="none"/>
          <circle cx="7" cy="12" r="1.5" fill="currentColor" stroke="none"/>
        </svg>
      )
    case 'file':
      return (
        <svg {...s}>
          <path d="M9.5 1.5H4a1 1 0 00-1 1v11a1 1 0 001 1h8a1 1 0 001-1V5L9.5 1.5z"/>
          <path d="M9.5 1.5V5H13M5.5 8.5h5M5.5 11h5"/>
        </svg>
      )
    case 'wallet':
      return (
        <svg {...s}>
          <path d="M2 4.5h11a1 1 0 011 1v7a1 1 0 01-1 1H2.5a1 1 0 01-1-1V3.5a1 1 0 011-1H11"/>
          <path d="M14 8h-3a1 1 0 000 2h3"/>
        </svg>
      )
  }
}
